import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import CheckboxMultipleFormInput from '@src/components/shared/form_elements/CheckboxMultipleFormInput.vue';
import type { CheckboxFormOption } from '@src/components/shared/form_fields/FormOptions';
import FieldContainer from '@src/components/patterns/FieldContainer.vue';

interface Props {
	incentiveFormFieldOptions: CheckboxFormOption[];
	modelValue: string[];
	isMaxWidthField?: boolean;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IncentivesField',
  props: {
    incentiveFormFieldOptions: {},
    modelValue: {},
    isMaxWidthField: { type: Boolean },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;

const emit = __emit;

const fieldModel = useFieldModel<string[]>( () => props.modelValue, props.modelValue );

const onUpdateModel = ( newValue: string[] ): void => {
	emit( 'update:modelValue', newValue );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldContainer, {
    "input-id": "tote_bag",
    "is-max-width-field": __props.isMaxWidthField
  }, {
    field: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.incentiveFormFieldOptions, (incentive) => {
        return (_openBlock(), _createBlock(CheckboxMultipleFormInput, {
          key: incentive.id,
          "native-value": incentive.value,
          name: "incentives",
          modelValue: _unref(fieldModel),
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
            onUpdateModel
          ],
          "input-id": incentive.id,
          "aria-describedby": __props.ariaDescribedby
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(incentive.label), 1)
          ]),
          _: 2
        }, 1032, ["native-value", "modelValue", "input-id", "aria-describedby"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["is-max-width-field"]))
}
}

})